const loginUser = (user) => {
    return {
        type: "LOGIN_USER",
        user
    }
}

const promotionAds = (ads) => {
    return {
        type: "PROMOTION_ADS",
        ads
    }
}

const removeUser = () => {
    return {
        type: "REMOVE_USER"
    }
}


export {
    loginUser,
    removeUser,
    promotionAds
}